// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__5Lnl1","topBorder":"styles_topBorder__PBDL_","centered":"styles_centered__zm5FV","disclaimer":"styles_disclaimer__v3eg4"};